import { Hero } from '@/routes/home/Hero';
import { HowItWorks } from '@/routes/home/HowItWorks';
import { TemplatesGallery } from '@/routes/home/TemplatesGallery';
import { FeaturesGrid } from '@/routes/home/FeaturesGrid';
import { PrivacySpotlight } from '@/routes/home/PrivacySpotlight';
import { Faq } from '@/routes/home/Faq';
import { FinalCta } from '@/routes/home/FinalCta';

export function Home() {
  return (
    <>
      <Hero />
      <HowItWorks />
      <TemplatesGallery />
      <FeaturesGrid />
      <PrivacySpotlight />
      <Faq />
      <FinalCta />
    </>
  );
}
